import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import "../../styles/loading-skeleton.css";

// Skeleton for Article Cards
export function ArticleCardSkeleton() {
  return (
    <Card className="article-card-view skeleton-card">
      <div className="skeleton skeleton-image" style={{ height: "200px" }} />
      <Card.Body>
        <div className="skeleton skeleton-title" />
        <div className="skeleton skeleton-text" />
        <div className="skeleton skeleton-text" />
        <div className="skeleton skeleton-text short" />
        <div className="skeleton-metadata">
          <div className="skeleton skeleton-badge" />
          <div className="skeleton skeleton-badge" />
        </div>
        <div className="skeleton-tags">
          <div className="skeleton skeleton-tag" />
          <div className="skeleton skeleton-tag" />
          <div className="skeleton skeleton-tag" />
        </div>
        <div className="skeleton skeleton-button" />
      </Card.Body>
    </Card>
  );
}

// Skeleton for Project Cards
export function ProjectCardSkeleton() {
  return (
    <Card className="project-card-view skeleton-card">
      <div className="skeleton skeleton-image" style={{ height: "200px" }} />
      <Card.Body>
        <div className="skeleton skeleton-title" />
        <div className="skeleton skeleton-text" />
        <div className="skeleton skeleton-text" />
        <div className="skeleton skeleton-text short" />
        <div className="skeleton skeleton-button" />
      </Card.Body>
    </Card>
  );
}

// Loading Grid for Articles
export function ArticlesLoadingGrid({ count = 6 }) {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      {[...Array(count)].map((_, index) => (
        <Col key={index} md={4} className="article-card">
          <ArticleCardSkeleton />
        </Col>
      ))}
    </Row>
  );
}

// Loading Grid for Projects
export function ProjectsLoadingGrid({ count = 6 }) {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      {[...Array(count)].map((_, index) => (
        <Col key={index} md={4} className="project-card">
          <ProjectCardSkeleton />
        </Col>
      ))}
    </Row>
  );
}

// Article Content Loading
export function ArticleContentSkeleton() {
  return (
    <div className="article-content-skeleton">
      <div className="skeleton skeleton-cover-image" />
      <div className="skeleton skeleton-heading" />
      <div className="skeleton-metadata-large">
        <div className="skeleton skeleton-badge" />
        <div className="skeleton skeleton-badge" />
        <div className="skeleton skeleton-badge" />
      </div>
      <div className="skeleton-tags-large">
        <div className="skeleton skeleton-tag" />
        <div className="skeleton skeleton-tag" />
        <div className="skeleton skeleton-tag" />
      </div>
      <div className="skeleton-content-body">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="skeleton-paragraph">
            <div className="skeleton skeleton-text" />
            <div className="skeleton skeleton-text" />
            <div className="skeleton skeleton-text" />
            <div className="skeleton skeleton-text short" />
          </div>
        ))}
      </div>
    </div>
  );
}